enum ProjectServiceStatus {
	Forecast = "Forecast",
	ToBeInvoiced = "ToBeInvoiced",
	Invoiced = "Invoiced",
	DoNotInvoice = "DoNotInvoice"
}

export default ProjectServiceStatus;
